import { useEffect } from "react";
import { useRemoveCompanyMutation } from "../../../../features/companyApi";
import { useRemovePersonMutation } from "../../../../features/peopleApi";
import { addBannerWithTimeout } from "../../../lib/centralizedBanner/slice";
import { ContactType } from "../../../lib/filters/dto";
import { useAppDispatch } from "../../../lib/redux/hooks";
import { ConfirmModal } from "../../../ui/organisms/confirmModal.tsx";

export function DeleteContact({ selectedIds, setSelectedIds, showModal, setShowModal, contactType }: { selectedIds: string[], setSelectedIds: (ids: string[]) => void, showModal: boolean, setShowModal: (show: boolean) => void, contactType: ContactType }) {
    const dispatch = useAppDispatch();
    const [removePeople, {
        isLoading: isDeletingPeople,
        reset: resetMutation
    }] = useRemovePersonMutation();

    const [removeCompanies, {
        isLoading: isDeletingCompanies,
        reset: resetCompaniesMutation
    }] = useRemoveCompanyMutation();

    useEffect(() => {
        return () => {
            resetMutation();
            resetCompaniesMutation();
        };
    }, [resetMutation, resetCompaniesMutation]);

    const handleCloseDeleteModal = () => {
        setShowModal(false);
        setSelectedIds([]);
        resetMutation();
        resetCompaniesMutation();
    };

    const handleDeletePeopleConfirm = async () => {
        if (selectedIds.length === 0) return;

        if (contactType === ContactType.PERSON) {
            try {
                await removePeople({ ids: selectedIds }).unwrap();

                setSelectedIds([]);
                handleCloseDeleteModal();
                dispatch(addBannerWithTimeout({
                    message: "Persona eliminata con successo",
                    variant: "success"
                }));

            } catch (error: any) {
                setSelectedIds([]);
                handleCloseDeleteModal();
                dispatch(addBannerWithTimeout({
                    message: "Si è verificato un errore durante l'eliminazione",
                    variant: "error"
                }));
            }
        } else {
            try {
                await removeCompanies(selectedIds).unwrap();

                setSelectedIds([]);
                handleCloseDeleteModal();
                dispatch(addBannerWithTimeout({
                    message: "Azienda eliminata con successo",
                    variant: "success"
                }));

            } catch (error: any) {
                setSelectedIds([]);
                handleCloseDeleteModal();
                dispatch(addBannerWithTimeout({
                    message: "Si è verificato un errore durante l'eliminazione",
                    variant: "error"
                }));
            }
        }
    };

    return (
        <ConfirmModal
            key={"delete-people-modal"}
            title={
                contactType === ContactType.PERSON ?
                    (selectedIds.length > 1 ?
                        "Elimina persone" :
                        "Elimina persona") :
                    (selectedIds.length > 1 ?
                        "Elimina aziende" :
                        "Elimina azienda")
            }
            loading={isDeletingPeople || isDeletingCompanies}
            label={
                contactType === ContactType.PERSON ?
                    (selectedIds.length > 1 ?
                        "Sei sicuro di voler eliminare queste persone?" :
                        "Sei sicuro di voler eliminare questa persona?") :
                    (selectedIds.length > 1 ?
                        "Sei sicuro di voler eliminare queste aziende?" :
                        "Sei sicuro di voler eliminare questa azienda?")
            }
            confirmAction={handleDeletePeopleConfirm}
            onClose={handleCloseDeleteModal}
            visible={showModal}
        />
    )
}